import { Group } from "@mantine/core";
import React from "react";
import OrderServiceReceiveActionButton from "./orderServiceReceiveActionButton";
import OrderServicePrintCoverSheetButton from "./orderServicePrintCoverSheetButton";
import OrderServicePrintSubmitCoverSheetButton from "./orderServicePrintSubmitCoverSheetButton";
import OrderServiceCancelButton from "./orderServiceCancelButton";
import OrderServiceCompleteButton from "./orderServiceCompleteButton";
import ActionPermissionGate from "./actionPermissionGate";

const OrderServiceActionList = ({ form }) => {
  return (
    <Group mt={10}>
      <ActionPermissionGate
        entity="orderService"
        action="printCoverSheet"
        requireFullAccess={false}
      >
        <OrderServicePrintCoverSheetButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="orderService" action="receive">
        <OrderServiceReceiveActionButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate
        entity="orderService"
        action="printSubmitCoverSheet"
        requireFullAccess={false}
      >
        <OrderServicePrintSubmitCoverSheetButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="orderService" action="cancel">
        <OrderServiceCancelButton mainForm={form} />
      </ActionPermissionGate>

      <ActionPermissionGate entity="orderService" action="complete">
        <OrderServiceCompleteButton mainForm={form} />
      </ActionPermissionGate>
    </Group>
  );
};

export default OrderServiceActionList;
